<header class="page-header">
	<div class="flex">
		<h2>Document Styling</h2>
	</div>
</header>

<form (ngSubmit)="save(form)" #form="ngForm" class="form">
	<div class="styles grid min-h-0 h-full overflow-y-scroll">
		<div class="flex flex-1 min-h-0">
			<div class="mb-4 flex-1">
				<div class="overflow-auto h-full">
					<h4 class="mt-0 pt-0">Formatting options</h4>
					<div *ngFor="let element of elements" class="my-2">
						<div class="mb-4" *ngIf="!element.hidden">
							<app-container>
								<div class="flex justify-between">
									<h4>{{ elementTagsMapping[element.tag].name }}</h4>
									<div *ngIf="element.wordExportOnly">
										<app-icon [icon]="icons.WARNING"></app-icon> Only applies
										for word export
									</div>
								</div>

								<div class="flex flex-col">
									<ng-container
										*ngFor="let style of element.styles; let i = index"
									>
										<ng-container *ngIf="!style.hidden">
											<app-input
												*ngIf="
													documentStylingInputTypes.STRING === style.inputType
												"
												orientation="row"
												class="mt-2"
												(debounce)="updateStyling()"
												[submitted]="form.submitted"
												required
												name="{{ style.type + i + element.tag }}"
												[label]="elementAttributesMapping[style.type].name"
												[(ngModel)]="style.value"
											></app-input>
											<app-dropdown
												*ngIf="
													documentStylingInputTypes.DROPDOWN === style.inputType
												"
												orientation="row"
												[label]="elementAttributesMapping[style.type].name"
												class="mt-2"
												(onSelect)="
													onDropdownSelect($event, element.tag, style.type)
												"
												name="{{ style.type + i + element.tag }}"
												[(ngModel)]="style.value"
												[itemGroups]="[{ items: style.dropdownOptions }]"
											></app-dropdown>
										</ng-container>
									</ng-container>
								</div>
							</app-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="preview">
		<div
			class="absolute w-full h-full opacity-40 bg-white z-30 flex justify-center items-center"
			*ngIf="loading"
		>
			<mat-spinner></mat-spinner>
		</div>

		<div class="flex">
			<atomic-button-group
				[ngModelOptions]="{ standalone: true }"
				type="tab"
				[(ngModel)]="currentState"
				(onClick)="switchPreview($event)"
				[options]="options"
			></atomic-button-group>
		</div>

		<app-html-pdf-viewer
			#documentViewer
			class="h-full"
			[customStyling]="customCssFromStyling"
			html="{{ showWordPreview ? '' : html }}"
		></app-html-pdf-viewer>
	</div>

	<div class="save border-t border-gray-200 py-4">
		<div class="w-full flex items-center justify-end">
			<app-button size="small" type="submit" [disabled]="disableSave"
				>Save all selections</app-button
			>
		</div>
	</div>
</form>
